import { useQuery } from 'react-query';

import { IForm1065, IForm1120s, IGetFormsList } from '../interfaces';
import { GET_FORMS_LIST_URL_MAP, URL_PARAMS } from '../consts';
import { useStore } from '../../../store';
import { httpService } from '../../../services/http.service';

export const useGetFormsList = ({ formType, disableAutoFetch, prevActiveYear }: IGetFormsList) => {
  const { customerId } = useStore(state => state.user);
  const dynamicUrl = GET_FORMS_LIST_URL_MAP[formType as keyof typeof GET_FORMS_LIST_URL_MAP];
  let formattedUrl = '';
  if (dynamicUrl) {
    formattedUrl = dynamicUrl.replace(URL_PARAMS.customerId, customerId);
  }

  return useQuery(
    'GetFormsList',
    async () => {
      const res = await httpService.get(formattedUrl);
      return { data: res.data as IForm1065 & IForm1120s, prevActiveYear: prevActiveYear || 0 };
    },
    {
      enabled: !disableAutoFetch,
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  );
};
